import { useEffect, useContext } from 'react';
import useNRLazyQuery from '../../graphql/useNRLazyQuery';
import { GET_ASSET } from '../../graphql/queries/asset';
import { ComponentContext } from '../../ContextWrappers/NRComponentContextWrapper';
import { useParams } from 'react-router-dom';
import isEqual from 'lodash.isequal';
import { useFlag } from '@openfeature/react-sdk';
import { FEATURE_FLAGS } from '../../constants/constants';

const useFetchAsset = () => {
  const { setAsset, asset, refetch, setRefetch } = useContext(ComponentContext);
  const { componentId } = useParams();
  // TODO: Remove feature flag checks and isPQCEnabled logic when certificates-pqc, public-key-pqc, and private-key-pqc feature flags are removed
  // Remove includeQuantumCapable from makeRequest variables and always query quantumCapable field directly
  const { value: isCertificatesPQCEnabled } = useFlag(FEATURE_FLAGS.CERTIFICATES_PQC, false);
  const { value: isPublicKeyPQCEnabled } = useFlag(FEATURE_FLAGS.PUBLIC_KEY_PQC, false);
  const { value: isPrivateKeyPQCEnabled } = useFlag(FEATURE_FLAGS.PRIVATE_KEYS_PQC, false);

  const isPQCEnabled = isCertificatesPQCEnabled || isPublicKeyPQCEnabled || isPrivateKeyPQCEnabled;

  const [, , called, makeRequest] = useNRLazyQuery({
    query: GET_ASSET,
    options: {
      variables: { args: { assetId: componentId }, includeQuantumCapable: isPQCEnabled },
      context: { version: 'v3' },
      fetchPolicy: 'cache-and-network'
    },
    qlObjKey: 'asset',
    transformData: data => {
      if (!isEqual(asset, data)) {
        setAsset(data);
      }
    }
  });

  useEffect(() => {
    if ((!asset && componentId && !called) || asset?.id !== componentId || !!refetch) {
      setRefetch(false);
      makeRequest({ variables: { args: { assetId: componentId }, includeQuantumCapable: isPQCEnabled }, context: { version: 'v3' } });
    }
  }, [componentId, refetch, isPQCEnabled]);
};

export default useFetchAsset;
